import { useContext } from 'react';

import { AppraisalListContext } from '../context/AppraisalListContext';

export const useAppraisalListContext = () => {
  return useContext(AppraisalListContext);
};
